import { axios } from "~/plugins/request"

export const state = () => {
	return {}
}
export const mutations = {}

export const actions = {
	list({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`/monthPlanWork/list`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  getCreateInfo({ commit }, data) {
		return new Promise((resolve, reject) => {
			axios({
        method: 'get',
        url: '/monthPlanWork/getCreateInfo',
        params: data
      })
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  findOrgTreeByCurrentUser({ commit }, data) {
		return new Promise((resolve, reject) => {
			axios({
        method: 'get',
        url: 'monthPlanWork/findOrgTreeByCurrentUser'
      })
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  getWeekList({ commit }) {
		return new Promise((resolve, reject) => {
			axios.get(`/monthPlanWork/getWeekList`)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  generateWeekReport({ commit }, data) {
		return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: '/monthPlanWork/generateWeekReport',
        params: data
      })
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  sgetWeekPlanOrReportList({ commit }, data) {
		return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: '/monthPlanWork/getWeekPlanOrReportList',
        params: data
      })
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  getSearchTitle({ commit }) {
		return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: '/monthPlanWork/getSearchTitle'
      })
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  getNoFinishList({ commit }, data) {
		return new Promise((resolve, reject) => {
      axios.post('/monthPlanWork/getNoFinishList', data)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  createNewPlan({ commit }, data) {
		return new Promise((resolve, reject) => {
			axios({
        method: 'get',
        url: '/monthPlanWork/createNewPlan',
        params: data
      })
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  save({ commit }, data) {
		return new Promise((resolve, reject) => {
			axios.post(`/monthPlanWork/saveWeekInfo`, data)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  saveWeekQuestion({ commit }, data) {
		return new Promise((resolve, reject) => {
			axios.post(`/monthPlanWork/saveWeekQuestion`, data)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  findById({ commit }, data) {
		return new Promise((resolve, reject) => {
			axios({
        method: 'get',
        url: '/monthPlanWork/findById',
        params: data
      })
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  delete({ commit }, data) {
		return new Promise((resolve, reject) => {
			axios({
        method: 'get',
        url: '/monthPlanWork/delete',
        params: data
      })
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
}





